import { useQuery } from "@tanstack/react-query";
import { LengthBarRow } from "../models/LengthBarRow";
import { getBarsByBundle } from "../repositories/lengthReportRepository";

type UseBarsByBundleProps = {
	bundleId: number | null;
	onError: (error: Error) => void;
};

export const useBarsByBundle = ({
	bundleId,
	onError,
}: UseBarsByBundleProps) => {
	return useQuery<LengthBarRow[], Error>({
		queryKey: ["barsByBundle", bundleId],
		queryFn: () => getBarsByBundle(bundleId!),
		onError,
		enabled: bundleId !== null,
	});
};
